export const convertCurrencySettings = currencySettings => {
  const isV1 = currencySettings.fractionSize != null;
  if (isV1) {
    const settings = currencySettings;
    return {
      code: settings.code,
      symbol: settings.symbol,
      minorUnits: settings.fractionSize,
      groupSeparator: settings.groupSep,
      negativePrefix: settings.negPrefix,
      decimalSeparator: settings.decimalSep,
      negativeSuffix: settings.negSuffix,
      positivePrefix: settings.posPrefix,
      positiveSuffix: settings.posSuffix
    };
  } else {
    const settings = currencySettings;
    return {
      code: settings.code,
      fractionSize: settings.minorUnits,
      decimalSep: settings.decimalSeparator,
      groupSep: settings.groupSeparator,
      negPrefix: settings.negativePrefix,
      negSuffix: settings.negativeSuffix,
      posPrefix: settings.positivePrefix,
      posSuffix: settings.positiveSuffix,
      symbol: settings.symbol
    };
  }
};
//# sourceMappingURL=convertCurrencySettings.js.map